export function generateDemoRisk() {

  const scenarios = [

    { score: 12, level: "SAFE" },

    { score: 24, level: "SAFE" },

    { score: 48, level: "WARNING" },

    { score: 67, level: "WARNING" },

    { score: 83, level: "CRITICAL" },

    { score: 95, level: "CRITICAL" }

  ];

  return scenarios[
    Math.floor(Math.random() * scenarios.length)
  ];
}